import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import AuthToken from './pages/AuthToken';
import AskPDF from './pages/AskPDF';
import DownloadPDFs from './pages/DownloadPDFs';
import PDFStatus from './pages/PDFStatus';
import ListPDFs from './pages/ListPDFs';
import HealthCheck from './pages/HealthCheck';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/auth-token" element={<AuthToken />} />
        <Route path="/ask-pdf" element={<AskPDF />} />
        <Route path="/download-pdfs" element={<DownloadPDFs />} />
        <Route path="/pdf-status" element={<PDFStatus />} />
        <Route path="/list-pdfs" element={<ListPDFs />} />
        <Route path="/health-check" element={<HealthCheck />} />
      </Routes>
    </Layout>
  );
}

export default App;
